import { createContext } from 'react'

export const GameConfigContext = createContext( {} )
